import {Product} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty,
} from "@flexinet/ui-components";
import { Stack } from '@mantine/core';
import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";
import { StripeProductButtons } from '../buttons/StripeProductButtons';
import { useState, useEffect } from 'react';

export const BillingProviderPropertyCard = ({record, onRecordUpdate}: { record: Product, onRecordUpdate?: (updates: Partial<Product>) => void }) => {
    const [product, setProduct] = useState(record);

    useEffect(() => {
        setProduct(record);
    }, [record]);

    const properties = [
        {
            label: 'Billing Provider',
            value: product.billingProviderId || '-',
            span: 12,
        }, {
            label: 'Billing Provider Record ID',
            value: product.billingProviderRecordId || '-',
            decorator: (value: string) => value !== '-' ? <PlatformPropertyCardCopyButtonDecorator value={value}/> : null,
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems()
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    const handleStripeProductUpdate = (stripeProductId: string) => {
        const updatedProduct = {
            ...product,
            billingProviderRecordId: stripeProductId
        };
        setProduct(updatedProduct);
        if (onRecordUpdate) {
            onRecordUpdate({
                billingProviderRecordId: stripeProductId
            });
        }
    };

    return (
        <Stack gap="md">
            <PlatformPropertyCard properties={allowedProperties}/>
            {product.billingProviderId && (
                <StripeProductButtons 
                    product={product} 
                    onProductUpdated={handleStripeProductUpdate}
                />
            )}
        </Stack>
    );
};